import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ReadingAidsChangeboardingSpotlight: LoadableType<{
	contentId: string;
	onGotItClick: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ReadingAidsChangeboardingSpotlight" */ '../src/ReadingAidsChangeboardingSpotlight.tsx'
			)
		).ReadingAidsChangeboardingSpotlight,
});

// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID } from '../src/ReadingAidsChangeboardingSpotlight.tsx';
